import { fillTheHeight, media } from '@anm/styles/helpers';
import styled from 'styled-components';

import { DayColumnProps } from '.';

export const DayColumnWrapperMobile = media.tablet`
  margin-left: 0;
  margin-bottom: 45px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const DayColumnWrapperDesktop = media.desktop_small`
  margin-left: 5px;
`;

export const DayTitleMobile = media.tablet`
  padding-top: 0;
`;

export const DayDateMobile = media.tablet`
  padding-bottom: 0;
`;

export const DayColumnContentDesktop = media.desktop_small`
  padding: 0 5px 5px;
`;

export const DayColumnContentMobile = media.tablet`
  padding: 20px 20px 20px 10px;
  flex-direction: row;
  > ul {
    flex: 1;
  }
`;

export const DateWrapperMobile = media.tablet`
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-end;
  padding-right: 10px;
  width: 100%;
  max-width: 102px;
  text-align: center;
`;

export const DateWrapper = styled.div`
  ${DateWrapperMobile};
`;

const DayColumnWrapper = styled.div`
  text-align: center;
  ${fillTheHeight};
  flex-direction: column;
  margin-left: 10px;
  overflow: hidden;
  border-radius: 8px;
  background: ${({ isActive }: DayColumnProps) =>
    isActive ? 'rgba(34, 148, 223, 0.2)' : '#ebeef5'};
  &:first-of-type {
    margin-left: 0;
  }
  ${DayColumnWrapperMobile};
  ${DayColumnWrapperDesktop};
`;

export const DayColumnContent = styled.div`
  padding: 0 10px 10px;
  ${fillTheHeight};
  justify-content: flex-start;
  align-items: stretch;
  flex-direction: column;
  flex-grow: 1;
  ${DayColumnContentDesktop};
  ${DayColumnContentMobile};
`;
export const DayDate = styled.div`
  padding: 1px 0 10px;
  color: #292a2b;
  font-size: 30px;
  font-weight: 300;
  ${DayDateMobile};
`;
export const DayTitle = styled.div`
  color: #919eaa;
  font-size: 16px;
  font-weight: 300;
  padding-top: 9px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 5px;
  padding-right: 5px;
  ${DayTitleMobile};
`;

export default DayColumnWrapper;
